// extracted by mini-css-extract-plugin
export default {"Form":"Form_Form__DMpDX","input":"Form_input__EwUhk","inputText":"Form_inputText__DpJqt","button":"Form_button__FAdM1"};